import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ChapterHubEvent from "../event/ChapterHubEvent";
import InitializeChapterHubEvent from "../event/InitializeChapterHubEvent";

export default class ChapterHubCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);

        this._handleChapterHubDestroyBound = this._handleChapterHubDestroy.bind(this);
    }

    execute(evt) {
        /** @type {InitializeChapterHubEvent} */
        const { chapterId } = evt.params.data;

        this._screenSkin = this.openScreen(SkinKeyRegistry.CHAPTER_HUB_SCREEN_SKIN, null, {
            chapterId,
            startHidden: true,
        });

        this._dispatcher.addEventListener(ChapterHubEvent.DESTROY, this._handleChapterHubDestroyBound);
    }

    _handleChapterHubDestroy(evt) {
        this._dispatcher.removeEventListener(ChapterHubEvent.DESTROY, this._handleChapterHubDestroyBound);

        this.closeScreen(this._screenSkin);
        this._screenSkin = null;
    }
}